import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'
import storage from '@/utils/localstorage'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
	const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
	const value = modulesFiles(modulePath)
	modules[moduleName] = value.default
	return modules
}, {})

// 状态
const state = {
	token: 'asjkjd',
	isCollapse: false,
	menuList: [], //菜单
	domainInfo: {},
	// 公司切换信息
	switchInfo: {
		companyList: [],
		settlementList: [],
		companyId: '',
		settlementId: '',
	},
	routePath: null,
	userInfo: {},
	isContract: 1,
	userPermissions: [],
	// 错误响应弹窗标志，避免重复弹出
	responseErrorMessageBoxMark: false,
	// 按钮类型
	buttonType: process.env.VUE_APP_BUTTON_TYPE,
	// 全局的loading状态控制
	loadingStatus: false,
}
const mutations = {
	/**
	 * @description 左侧导航折叠状态控制
	 * @author YM
	 * @date 2019-01-10
	 * @param {*} state
	 */
	changeCollapse(state) {
		state.isCollapse = !state.isCollapse
	},
	handleCollapse(state, data) {
		state.isCollapse = data
	},
	handleIsContract(state, data) {
		state.isContract = data
	},
	/**
	 * @description 处理菜单
	 * @author YM
	 * @date 2019-01-10
	 * @param {*} state
	 * @param {*} data
	 */
	handleMenuList(state, data) {
		state.menuList = data
	},
	/**
	 * @description 处理地址栏url路由
	 * @author YM
	 * @date 2019-01-14
	 * @param {*} state
	 * @param {*} data
	 */
	handleRoutePath(state, data) {
		state.routePath = data
	},
	/**
	 * @description 处理用户登录信息
	 * @author YM
	 * @date 2019-01-10
	 * @param {*} state
	 * @param {*} data
	 */
	handleUserInfo(state, data) {
		state.userInfo = data
	},
	/**
	 * @description 处理用户权限信息
	 * @author YM
	 * @date 2019-01-10
	 * @param {*} state
	 * @param {*} data
	 */
	handleUserPermissions(state, data) {
		state.userPermissions = data
	},
	/**
	 * @description 改变响应错误弹窗标志
	 * @author YM
	 * @date 2020-01-07
	 * @param {*} state
	 * @param {*} data  true|false
	 */
	changeRespErrMsgBoxMark(state, data) {
		state.responseErrorMessageBoxMark = data
	},
	/**
	 * @description 全局loading状态控制
	 * @author YM
	 * @date 2020-02-19
	 * @param {*} state
	 * @param {*} data  true|false
	 */
	changeLoadingStatus(state, data) {
		state.loadingStatus = data
	},
	changeSwitchInfo(state, {
		key,
		value
	}) {
		state.switchInfo[key] = value
	},
	handleDomainInfo(state, data) {
		state.domainInfo = data
	}
}

const actions = {
	// 获取权限列表
	async getUserPermissions({commit}) {
	// 获取权限
	let userPermissionsList = await api.getUserPermissionsList();
	let objStr = JSON.stringify(userPermissionsList)
	localStorage.setItem('permission',objStr)
	commit('handleUserPermissions', userPermissionsList)
	},
	// 刷新Token
	async refreshToken() {
		const result = await api.refreshToken()
		console.log("refreshToken=>res", result)
		if (result) {
			// jwt 赋值
			storage.set('jwt', result.access_token)
			storage.set('jwtTime', result.time * 1000)
		}
		return Promise.resolve(true)
	},

	// // 首页切换公司和服务公司
	async initSwitch() {
		// dispatch('initUserInfo')
	},
	// 获取用户信息
	async initUserInfo({
		commit
	}) {
		const userInfo = await api.getUserDetail()
		if (userInfo) {
			storage.set('user_info', userInfo)
			commit('handleUserInfo', userInfo)
		}
		return userInfo
	}
}

const getters = {
	menuList: state => state.menuList,
	isCollapse: state => state.isCollapse,
	routePath: state => state.routePath,
	userInfo: state => state.userInfo,
	userPermissions: state => state.userPermissions,
	respErrMsgBoxMark: state => state.responseErrorMessageBoxMark,
	buttonType: state => state.buttonType,
	loadingStatus: state => state.loadingStatus,
}

export default new Vuex.Store({
	strict: false,
	state,
	getters,
	mutations,
	actions,
	modules
})
